import * as _ from 'lodash-es';
import {ApiConfig as IApiConfig} from 'appConfig';
import {getUrlRelativeToPublicPath} from '../common/public-path';

const ROOT_URL_REGEXP = /^(http|ws)s?:\/\//i;
const PUBLIC_PATH_URL_REGEXP = /^\.\//;

export class ApiConfig implements IApiConfig {

    [key: string]: any;

    public root: string;

    constructor(params: IApiConfig) {
        this.root = _.trimEnd(params.root, '/');

        _.forEach(params, (value: string, key: string) =>

            // Allow setting empty value in order to disable something
            this[key] = _.isNil(value)
                ? value
                : this.getPath(value)
        );
    }

    public getPath(url: string): string {
        let resultPath: string = url;

        // Handle publicPath relative URLs.
        if (PUBLIC_PATH_URL_REGEXP.test(url)) {
            resultPath = getUrlRelativeToPublicPath(url);

            // Handle API relative URLs.
        } else if (!ROOT_URL_REGEXP.test(url)) {
            resultPath = [
                this.root,
                url
            ]
                .filter(Boolean)
                .join('/');
        }

        return resultPath;
    }

}
